module.exports = __webpack_public_path__ + "media/images/emblems/Ufhusen_LU-07ea188528228e950c2f8e6f31564843.png";